import {
	FOCUSED_FRIEND_LIST,
	FOCUSED_PRIVATE_CHATS,
	PENDING_FRIEND_REQUESTS_CHANGED,
	friendStates,
	CHANGE_FRIEND_TAB,
	SET_SELECTED_CHAT,
	SET_MY_CHAT_ROOMS,
	TOGGLE_CHAT_SIDEBAR,
	TOGGLE_CHAT_USERLIST_SIDEBAR,
	MAIN_CHAT_USERLIST_TOGGLE,
	mainChatUserlistToggle,
	MAIN_CHAT_VISIBLE_TOGGLED_ON,
	SET_EDIT_MESSAGE,
	END_EDIT_MESSAGE,
	SUBMIT_MESSAGE_EDIT_BEGIN,
	SUBMIT_MESSAGE_EDIT_FAIL,
	SUBMIT_MESSAGE_EDIT_SUCCESS,
	CHAT_MESSAGE_DELETE_HIGHLIGHT_BEGIN,
	CHAT_MESSAGE_DELETE_HIGHLIGHT_END,
	MAIN_CHAT_MINIMIZED_TOGGLE,
	VISIBLE_USERLIST_UPDATED,
	GET_CLOSED_PRIVATE_CHATS_BEGIN,
	GET_CLOSED_PRIVATE_CHATS_FAIL,
	GET_CLOSED_PRIVATE_CHATS_SUCCESS,
	CHAT_GENERAL_STATE_UPDATE, TOGGLE_CHAT_RULES_VISIBLE, EDIT_MESSAGE_TEXT_UPDATE,
	CHAT_ROOM_DESCRIPTION_UPDATES
} from '../actions/chat';
import getUrlParameter from 'functions/getUrlParameter';
import { ladderLocalStorage } from 'components/Ladder';
import { POPUP_CLOSE } from '../actions/popups';


const initialState = {
	currentFocusedChat: 'friends',
	pendingFriendRequests: 0,
	autoOpenedPrivateChat: getUrlParameter('send_message'),
	currentFocusedFriendTab: ladderLocalStorage.getItem('friendComponentSelectTab', friendStates.friends),
	mainChatUserlistToggledOn: ladderLocalStorage.getItem('mainChatUserlistToggledOn', true),
	selectedMainChat: null,
	myChatRooms: undefined,
	chatLargeNotificationShown: ladderLocalStorage.getItem('chatLargeNotificationShown', false),
	chatLargeMinimized: ladderLocalStorage.getItem('chatLargeMinimized', false),
	chatLargeToggledOn: true,
	chatSidebarOpen: false,
	chatUserlistSidebarOpen: false,

	editingChatMessageId: null,
	editingChatMessageType: null,
	chatMessageDeleteHighlightPlayerId: null,
	chatMessageDeleteHighlightContext: null,

	loadingClosedPrivateChats: false,
	loadedPrivateChats: null,
	submittingEditChatMessages: {},
	chatsWithUnreadMessages: {},
	chatsWithNewMentions: {},
	aChatHasUnreadMessages: false,
	aChatHasNewMentions: false,
	editingChatMessageText: '',
	chatRulesToggledOn: false,
	chatRoomDescriptionUpdates: 0,

};

export default (state = initialState, action) => {
	switch(action.type) {
		case CHAT_ROOM_DESCRIPTION_UPDATES: {
			return {
				...state,
				chatRoomDescriptionUpdates: state.chatRoomDescriptionUpdates + 1
			};
		}
		case CHAT_GENERAL_STATE_UPDATE: {
			return {
				...state,
				...action.payload,
			};
		}
		case GET_CLOSED_PRIVATE_CHATS_BEGIN: {
			return {
				...state,
				loadingClosedPrivateChats: null,
			};
		}
		case GET_CLOSED_PRIVATE_CHATS_SUCCESS: {
			return {
				...state,
				loadedPrivateChats: action.payload,
				loadingClosedPrivateChats: false
			};
		}
		case GET_CLOSED_PRIVATE_CHATS_FAIL: {
			return {
				...state,
				loadingClosedPrivateChats: false,
			};
		}
		case CHAT_MESSAGE_DELETE_HIGHLIGHT_BEGIN: {
			return {
				...state,
				chatMessageDeleteHighlightPlayerId: action.payload.player.id,
				chatMessageDeleteHighlightContext: action.payload.context
			};
		}
		case POPUP_CLOSE:
		case CHAT_MESSAGE_DELETE_HIGHLIGHT_END: {
			return {
				...state,
				chatMessageDeleteHighlightPlayerId: null,
				chatMessageDeleteHighlightContext: null,
			};
		}
		case EDIT_MESSAGE_TEXT_UPDATE: {
			return {
				...state,
				editingChatMessageText: action.payload
			};
		}
		case SUBMIT_MESSAGE_EDIT_BEGIN: {
			const { idType, chatMessageId, text } = action.payload;
			const submittingEditChatMessages = { ...state.submittingEditChatMessages };
			submittingEditChatMessages[chatMessageId] = {
				idType,
				text
			};
			return {
				...state,
				submittingEditChatMessages,
				editingChatMessageId: null,
			};
		}
		case SUBMIT_MESSAGE_EDIT_FAIL: {
			const { idType, chatMessageId } = action.payload;
			const submittingEditChatMessages = { ...state.submittingEditChatMessages };
			if(submittingEditChatMessages[chatMessageId] && submittingEditChatMessages[chatMessageId].idType === idType) {
				delete submittingEditChatMessages[chatMessageId];
			}
			return {
				...state,
				submittingEditChatMessages,
			};
		}
		case SUBMIT_MESSAGE_EDIT_SUCCESS: {
			const { idType, chatMessageId } = action.payload;
			const submittingEditChatMessages = { ...state.submittingEditChatMessages };
			if(submittingEditChatMessages[chatMessageId] && submittingEditChatMessages[chatMessageId].idType === idType) {
				delete submittingEditChatMessages[chatMessageId];
			}
			return {
				...state,
				submittingEditChatMessages,
			};
		}
		case END_EDIT_MESSAGE: {
			return {
				...state,
				editingChatMessageId: null,
			};
		}
		case SET_EDIT_MESSAGE: {
			const { text, chatMessageId, idType } = action.payload;
			return {
				...state,
				editingChatMessageId: chatMessageId,
				editingChatMessageType: idType,
				editingChatMessageText: text,
			};
		}
		case MAIN_CHAT_VISIBLE_TOGGLED_ON: {
			const setTo = !state.chatLargeToggledOn;
			ladderLocalStorage.setItem('chatLargeToggledOn', setTo);
			return {
				...state,
				chatLargeToggledOn: setTo,
				chatLargeNotificationShown: true,
			};
		}
		case MAIN_CHAT_MINIMIZED_TOGGLE: {
			const setTo = !state.chatLargeMinimized;
			ladderLocalStorage.setItem('chatLargeMinimized', setTo);
			return {
				...state,
				chatLargeMinimized: setTo,
			};
		}
		case MAIN_CHAT_USERLIST_TOGGLE: {
			const setTo = !state.mainChatUserlistToggledOn;
			ladderLocalStorage.setItem('mainChatUserlistToggledOn', setTo);
			return {
				...state,
				mainChatUserlistToggledOn: setTo
			};
		}
		case TOGGLE_CHAT_SIDEBAR: {
			const setTo = action.payload !== null ? action.payload : !state.chatSidebarOpen;
			const newState = {
				...state
			};
			if(setTo) {
				newState.chatUserlistSidebarOpen = false;
			}
			newState.chatSidebarOpen = setTo;
			return newState;
		}
		case TOGGLE_CHAT_RULES_VISIBLE: {
			const setTo = action.payload !== null ? action.payload : !state.chatRulesToggledOn;
			const newState = {
				...state
			};
			newState.chatRulesToggledOn = setTo;
			return newState;
		}
		case TOGGLE_CHAT_USERLIST_SIDEBAR: {
			const setTo = action.payload !== null ? action.payload : !state.chatUserlistSidebarOpen;
			const newState = {
				...state
			};
			if(setTo) {
				newState.chatSidebarOpen = false;
			}
			newState.chatUserlistSidebarOpen = setTo;
			return newState;
		}
		case SET_MY_CHAT_ROOMS: {
			return {
				...state,
				myChatRooms: action.payload instanceof Map ? new Map(action.payload) : action.payload,
			};
		}
		case SET_SELECTED_CHAT:
			return {
				...state,
				selectedMainChat: action.payload
			};
		case CHANGE_FRIEND_TAB: {
			ladderLocalStorage.setItem('friendComponentSelectTab', action.payload.tab);
			return {
				...state,
				currentFocusedFriendTab: action.payload.tab,
			};
		}
		case PENDING_FRIEND_REQUESTS_CHANGED: {
			const count = action.payload;
			return {
				...state,
				pendingFriendRequests: count,
			};
		}
		case FOCUSED_FRIEND_LIST:
			return {
				...state,
				currentFocusedChat: 'friends',
			};
		case FOCUSED_PRIVATE_CHATS:
			return {
				...state,
				currentFocusedChat: 'private',
			};
		case VISIBLE_USERLIST_UPDATED:
			return {
				...state,
				visibleUserlistUsers: action.payload
			};
		default:
			return state;
	}
}